import styled from 'styled-components';

export const FormRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: flex-start;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const FormField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div {
    min-height: auto;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  display: flex;
  align-items: center;
  gap: 4px;

  &.required::after {
    content: '*';
    color: #dc3545;
    margin-left: 2px;
  }
`;

export const NoteSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;

  div {
    min-height: auto;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  width: 100%;
`;

const BaseButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(BaseButton)`
  background: #ffffff;
  color: #0a0a0a;
  border: 1px solid #0000001a;

  &:hover:not(:disabled) {
    background: #f8f9fa;
  }
`;

export const SubmitButton = styled(BaseButton)`
  background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
  color: #ffffff;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 13px;
  margin-top: 12px;
  padding: 8px 12px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
`;

export const CharacterCount = styled.div`
  font-size: 12px;
  color: #6c757d;
  text-align: right;
  margin-top: 4px;
`;
